export default "__VITE_ASSET__oJzSxqJN__"